import React from 'react';

const Erc20Icon = (props) => (
  <svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="30" height="20" rx="2" fill="#627EEA"/>
    <path d="M14.9987 2.50146V8.04521L19.6844 10.139L14.9987 2.50146Z" fill="white" fillOpacity="0.602"/>
    <path d="M14.9987 2.50146L10.3125 10.139L14.9987 8.04521V2.50146Z" fill="white"/>
    <path d="M14.9987 13.7312V17.4981L19.6875 11.0112L14.9987 13.7312Z" fill="white" fillOpacity="0.602"/>
    <path d="M14.9987 17.4981V13.7306L10.3125 11.0112L14.9987 17.4981Z" fill="white"/>
    <path d="M14.9987 12.8595L19.6844 10.1389L14.9987 8.04639V12.8595Z" fill="white" fillOpacity="0.2"/>
    <path d="M10.3125 10.1389L14.9987 12.8595V8.04639L10.3125 10.1389Z" fill="white" fillOpacity="0.602"/>
  </svg>
);

export default Erc20Icon;
